import React from 'react'
import styled from 'styled-components'
import Img from 'gatsby-image'
import { StaticQuery, graphql } from 'gatsby'

import MoreLessButton from '../generals/MoreLessBtn'

const IlPaeseStyle = styled.div`
  grid-column: 1/4;

  @media screen and (max-width: 1112px) {
    grid-column: 1/3
  }

  @media screen and (max-width: 800px) {
    grid-column: 1/2
  }
  
  .ozzeroPageContent {
    display: grid;
    grid-gap: 20px;
    grid-template-columns: 1fr;
  }

  h5 {
    margin-top: 4px;
    color: #A0A0A0;
  }

  .ozzeroPageGalleryContainer {
    margin-top: 20px;
    display: grid;
    grid-gap: 20px;
  }

  @media screen and (min-width: 1112px) {
    .ozzeroPageContent {
      display: grid;
      grid-gap: 20px;
      grid-template-columns: 1fr 1fr;
      margin-top: 20px;
    }

    .ozzeroPageGalleryContainer {
      grid-template-columns: 1fr 1fr;
    }
  }

  @media screen and (min-width: 1366px) {
    .ozzeroPageGalleryContainer {
      grid-template-columns: 1fr 1fr 1fr;
    }
  }
`;

export default class IlPaese extends React.Component {
  state = {
    galleryShowMore: true,
    galleryBtnShow: true
  }

  setShowMoreBtn = () => {
    this.setState({
      galleryShowMore: !this.state.galleryShowMore
    })
  }

  updateDimensionsOzzeroGallery() {
    if (document.body.offsetWidth >= 1112) {
      this.setState({
        galleryShowMore: false,
        galleryBtnShow: false
      })
    } else {
      this.setState({
        galleryShowMore: true,
        galleryBtnShow: true
      })
    }
  }

  componentDidMount = () => {
    this.updateDimensionsOzzeroGallery();
    window.addEventListener("resize", this.updateDimensionsOzzeroGallery.bind(this));
  }

  render() {
    return (
      <StaticQuery
        query={graphql`
          query {
            allFile(filter: {relativeDirectory: { eq: "assets/images/old" }}, sort: { fields: [name] }) {
              edges {
                node {
                  id
                  childImageSharp {
                    fluid(maxWidth: 3000) {
                      ...GatsbyImageSharpFluid
                    }
                  }
                }
              }
            }
          }
        `}
        render={data => (
          <IlPaeseStyle>
            <div className="ozzeroPageContent">
              <Img sizes={data.allFile.edges[0].node.childImageSharp.fluid} />
              <p>Ozzero è un piccolo paese antico e ricco di storie da scoprire.<br/>
              I ritrovamenti di alcune necropoli risalenti al VI sec. a.C. ci svelano che i primi insediamenti sul suo territorio furono di origine gallica.<br/>
              Varie dominazioni hanno lasciato la loro impronta nei secoli successivi, come quella dei Romani e successivamente dei Longobardi, che contribuirono a far crescere e arricchire il nostro territorio, particolarmente fertile e accogliente grazie alla vicinanza del Ticino e alla grande presenza di acqua.<br/>
              Sono molti gli eventi che nel corso degli anni si sono intrecciati con la storia del nostro paese e che hanno visto Ozzero svolgere spesso un ruolo attivo, come nelle lotte tra Visconti e Torriani (XIII secolo) o nel corso della II Guerra Mondiale.<br/>
              Tutte queste storie hanno contribuito a creare il paese che vediamo oggi e, girando per le sue stradine e tra le mura dei palazzi ricchi di storia e cultura, possiamo ancora riviverle e riscoprirle.</p>
            </div>
            <h2 style={{marginTop: '20px'}}>Galleria fotografica</h2>
            <h5>{data.allFile.edges.length-1} immagini disponibili</h5>
            <div className="ozzeroPageGalleryContainer">
              {this.state.galleryShowMore ?
                data.allFile.edges.slice(1,3).map(({ node }, i) => {
                  return <Img key={node.id} sizes={node.childImageSharp.fluid} />
                })
                :
                data.allFile.edges.slice(1).map(({ node }, i) => {
                  return <Img key={node.id} sizes={node.childImageSharp.fluid} />
                })
              }
            </div>
            {this.state.galleryBtnShow &&
              <MoreLessButton state={this.state.galleryShowMore} changeState={this.setShowMoreBtn}/>
            }
          </IlPaeseStyle>
        )}
      />
    )
  }
}